export default __webpack_public_path__ + "locales/zh-CN/PaymentsEnterprise.json?hash=ef1b89b4e7e43535f5cf2667697ca9cd";